import { Component, OnInit, Input } from '@angular/core';
import { EditorCommonsOptions } from '../../../editor.commons.options';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

// Importamos Servicio
import { LandingService } from '../../../../services/landing.service';

@Component({
  selector: 'app-input-simple-group-repetible',
  templateUrl: './input-simple-group-repetible.component.html',
  styleUrls: ['./input-simple-group-repetible.component.scss']
})
export class InputSimpleGroupRepetibleComponent implements OnInit {
  
  @Input() data: any;
  
  constructor(
    private dataLandingService: LandingService
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  removeField(index){
    this.data.items.splice(index,1);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }
  
  addField(_data){

      let title = new EditorCommonsOptions().schema.text;
      title.properties.data = this.dataLandingService.getCustomValue('features',"random");
      title.properties.label = "Feature";

      let icon = new EditorCommonsOptions().schema.media;
      icon.properties.label = "Icon";

      let item = {
        "visible": true,
        "title": title,
        "icon": icon,
      };
      // Incluimos en items la funcionalidad
      _data.items.push(item);

  
  }

}
